import React from 'react';
import styles from './Eyebrow.module.css';

interface EyebrowProps {
  children: React.ReactNode;
}

export function Eyebrow({ children }: EyebrowProps) {
  return <p className={styles.root}>{children}</p>;
}
